import type { ParticipantNote } from '@seen/core/models/participantNote'
import { resolveId } from '@seen/core/references'
import type { JSX } from 'react'
import { TextLink } from '#src/components/core/TextLink.tsx'
import { useParticipantNoteTitle } from '#src/hooks/useParticipantNoteTitle.ts'
import { TimelineNoteSummary } from '#src/pages/participants/timeline/TimelineNoteSummary.tsx'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'

interface ParticipantNoteTimelineItemProps {
  participantNote: ParticipantNote
}

export function ParticipantNoteTimelineItem({
  participantNote,
}: ParticipantNoteTimelineItemProps): JSX.Element {
  const title = useParticipantNoteTitle(participantNote)
  return (
    <TimelineTextEntry
      actor={participantNote.signerReference ?? participantNote.owner}
      time={participantNote.signedOn ?? participantNote.lastUpdated}
      action={
        <>
          {participantNote.signerReference ? 'signed a' : 'created a'} note{' '}
          <TextLink
            to={`/Patient/${resolveId(participantNote.participant)}/visit-notes/${participantNote.id}`}
          >
            {title}
          </TextLink>
        </>
      }
      reference={participantNote.reference}
      originTask={participantNote.queuedEditsOriginTask}
      detail={
        <TimelineNoteSummary
          aiSummary={participantNote.aiSummary}
          aiSummaryGeneratedAt={participantNote.aiSummaryGeneratedAt}
          isSigned={participantNote.isSigned}
        />
      }
    />
  )
}
